module.exports = __webpack_public_path__ + "media/images/webpage/hotels/9494/room-dd4b64d1bd6d341c2d3da4ac0ac9f612.webp";